/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Max_PlayersInputs */



/**
* | output |
* | --- |
* | "Registration cap" |
*
* @param {Og_Cfg_Max_PlayersInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_max_players = /** @type {((inputs?: Og_Cfg_Max_PlayersInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Max_PlayersInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plafond des inscriptions")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tope de inscripciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Teto de inscrições")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tetto iscrizioni")
	return /** @type {LocalizedString} */ ("Registration cap")
});